export default __webpack_public_path__ + "static/betterwork-banner-3811b32443d429d11175e57af262df5e.png";